import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Categories from "@/components/Categories";
import Portfolio from "@/components/Portfolio";
import Process from "@/components/Process";
import WhyGarmond from "@/components/WhyGarmond";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Impresum from "@/components/Impresum";
import PolitikaPrivatnosti from "@/components/PolitikaPrivatnosti";
import ServicePage from "@/components/ServicePage";
import { QuoteProvider } from "@/components/QuoteDialog";
import usePageMeta from "@/hooks/usePageMeta";

function Home() {
  const location = useLocation();

  usePageMeta({
    title: "Garmond Graphic | Štampa i brendiranje Sarajevo",
    description:
      "Garmond Graphic Sarajevo - štampa, brendiranje i vizuelna rješenja za firme, događaje, sportske klubove i institucije. Od 1994. godine.",
    path: "/",
  });

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({ behavior: "smooth" }));
      }
    }
  }, [location.hash]);

  return (
    <>
      <Hero />
      <TrustStrip />
      <Categories />
      <Portfolio />
      <Process />
      <WhyGarmond />
      <Faq />
      <Contact />
    </>
  );
}

// Nova stranica se otvara na vrhu (osim kad link vodi na sekciju).
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <QuoteProvider>
    <div className="min-h-screen" data-testid="app-root">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/usluge/:slug" element={<ServicePage />} />
          <Route path="/impresum" element={<Impresum />} />
          <Route path="/politika-privatnosti" element={<PolitikaPrivatnosti />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
    </QuoteProvider>
  );
}

export default App;
